import { Navigate, Outlet } from "react-router-dom";

import { LoadingState } from "~/common/components";
import { isUserVerified } from "~/common/utils";
import { useGetCurrentTeamMember } from "../hooks";
import { ROUTES } from "./routes";

export const VerifiedRoutes = () => {
  const { data: teamMember } = useGetCurrentTeamMember();

  if (!teamMember) return <LoadingState className="h-screen" />;

  return isUserVerified(teamMember) ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTES.verification} />
  );
};
